import { toast } from "react-toastify";

export const showSuccessToast = (text, autoCloseTime = 1500) => {
  toast.success(text, {
    autoClose: autoCloseTime,
    icon: true, // Icons are now shown by default in v8+, but explicit for clarity
  });
};

export const showErrorToast = (text) => {
  toast.error(text, {
    autoClose: 5000,
    icon: true, // Icons are now shown by default in v8+, but explicit for clarity
  });
};

export const showInfoToast = (text) => {
  toast.info(text, {
    autoClose: 3000,
    icon: true, // Icons are now shown by default in v8+, but explicit for clarity
  });
};



